/* Common Imports */

import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";
import ProgressBar from "./sub-component/ProgressBar";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
  },
  scoreHeading: {
    fontSize: "1rem !important",
    fontWeight: 600,
    color: "#202020",
    margin: "1.5rem 0rem 0.5rem 0rem",
  },
  progressBar: {
    marginBottom: "1rem",
  },
  description: {
    marginTop: "-0.5rem",
    fontSize: "0.875rem",
    fontWeight: 400,
    color: "#666666",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.only("md")]: {
      fontSize: "1rem",
    },
  },
}));

const BeegruScore = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            Lighter Advisory Score
          </Typography>
          <div>
            {/* Approval Stage */}
            <Typography
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Approval Stage
            </Typography>
            <ProgressBar
              id="approval"
              className={classes.progressBar}
              value={props.values ? props.values.approval.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.approval.description
                : "OC has been received and the JP Nagar Dollar’s colony area infrastructure has completely developed"}
            </Typography>

            {/* Vaastu */}
            <Typography
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Vaastu
            </Typography>
            <ProgressBar
              id="vaastu"
              className={classes.progressBar}
              value={props.values ? props.values.vaastu.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.vaastu.description
                : "Flats are Vaastu compliant with Master bedrooms in south west and kitchens in southeast/Northwest"}
            </Typography>

            {/* Location Value */}
            <Typography
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Location Value
            </Typography>
            <ProgressBar
              id="location"
              className={classes.progressBar}
              value={props.values ? props.values.location.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.location.description
                : "JP Nagar dollars colony is a well-developed neighborhood. The location of this apartment is also connected to the bannerughatta road. The location is not very noisy but is very easily accessible from JP nagar side and Bannerughtta side."}
            </Typography>

            {/* Neighborhood */}
            <Typography
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Neighborhood
            </Typography>
            <ProgressBar
              id="neighbourhood"
              className={classes.progressBar}
              value={props.values ? props.values.neighbourhood.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.neighbourhood.description
                : "Neighborhood is posh. Large house and big cars. The entire apartment complex is completely populated with an active association managing the premises."}
            </Typography>

            {/* Value for Money */}
            <Typography
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Value for Money
            </Typography>
            <ProgressBar
              id="value"
              className={classes.progressBar}
              value={props.values ? props.values.value.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.value.description
                : "The building is a complete Myvan complete RCC structure, one of the bestbuildings in the locality. There is great value for the property considering the price, the construction quality and the location."}
            </Typography>

            {/* Overall */}
            <Typography
              id="overall"
              variant="body2"
              component="p"
              className={classes.scoreHeading}
            >
              Overall
            </Typography>
            <ProgressBar
              id="average"
              className={classes.progressBar}
              value={props.values ? props.values.average.score : 9}
              animation="accelerate"
            />
            <Typography variant="body2" className={classes.description}>
              {props.values
                ? props.values.average.description
                : "A great place to live, a premium apartment in a posh locality. Highly Recommended!"}
            </Typography>
          </div>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              Lighter Advisory Score
            </Typography>
          </Skeleton>
          <div>
            {/* Approval Stage */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Approval Stage
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="approval"
                className={classes.progressBar}
                value={props.values ? props.values.approval.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.approval.description
                  : "OC has been received and the JP Nagar Dollar’s colony area infrastructure has completely developed"}
              </Typography>
            </Skeleton>

            {/* Vaastu */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Vaastu
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="vaastu"
                className={classes.progressBar}
                value={props.values ? props.values.vaastu.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.vaastu.description
                  : "Flats are Vaastu compliant with Master bedrooms in south west and kitchens in southeast/Northwest"}
              </Typography>
            </Skeleton>

            {/* Location Value */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Location Value
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="location"
                className={classes.progressBar}
                value={props.values ? props.values.location.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.location.description
                  : "JP Nagar dollars colony is a well-developed neighborhood. The location of this apartment is also connected to the bannerughatta road. The location is not very noisy but is very easily accessible from JP nagar side and Bannerughtta side."}
              </Typography>
            </Skeleton>

            {/* Neighborhood */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Neighborhood
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="neighbourhood"
                className={classes.progressBar}
                value={props.values ? props.values.neighbourhood.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.neighbourhood.description
                  : "Neighborhood is posh. Large house and big cars. The entire apartment complex is completely populated with an active association managing the premises."}
              </Typography>
            </Skeleton>

            {/* Value for Money */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Value for Money
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="value"
                className={classes.progressBar}
                value={props.values ? props.values.value.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.value.description
                  : "The building is a complete Myvan complete RCC structure, one of the bestbuildings in the locality. There is great value for the property considering the price, the construction quality and the location."}
              </Typography>
            </Skeleton>

            {/* Overall */}
            <Skeleton>
              <Typography
                variant="body2"
                component="p"
                className={classes.scoreHeading}
              >
                Overall
              </Typography>
            </Skeleton>
            <Skeleton width="100%">
              <ProgressBar
                id="average"
                className={classes.progressBar}
                value={props.values ? props.values.average.score : 9}
                animation="accelerate"
              />
              <Typography variant="body2" className={classes.description}>
                {props.values
                  ? props.values.average.description
                  : "A great place to live, a premium apartment in a posh locality. Highly Recommended!"}
              </Typography>
            </Skeleton>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
};

export default BeegruScore;
